<template>
<div style="">
<div v-if="isLoading" class="loading">Loading&#8230;</div> 

<div class="columns is-gapless">
<div class="column is-4 is-size-4 has-text-weight-bold has-background-white has-text-right">
     <span class="icon is-small has-text-left"><i class="fas fa-user-plus"></i></span> &nbsp;&nbsp;&nbsp;&nbsp;NOUVEL GROUPE(S) &nbsp;&nbsp;&nbsp;&nbsp;
</div>
 
<div class="column is-1 has-tooltip-bottom has-tooltip-success" data-tooltip="Nouveau Groupe">
    <button @click="group_add_click()" class="button is-fullwidth has-background-info-light has-text-dark">
        <span class="icon is-small has-text-left"><i class="fas fa-plus"></i></span>     
    </button> 
</div>

<div class="column is-3"></div>

<div class="column is-2"> 
    <button @click="group_insert_check_confirm()" class="button is-fullwidth has-background-success has-text-white">
        <span class="icon is-small has-text-left"><i class="fas fa-save"></i></span>     
    </button> 
</div>

</div>
 

<!-- NEW GROUPE  -->
    <div v-for="(dataG,index) in data_add_group" :key="randomKey(index)">
        <CompGroupAdd
        :batchIndex="index"
        :dataGrp="dataG"
        :data_profs="data_profs"
        :data_codes="data_codes"
        :data_courses="data_courses"
        @emit_course_remove="emit_course_remove"
        @emit_student_list="emit_student_list"
        :key="randomKey()"
        > </CompGroupAdd>
    </div>


</div>
</template>

<script>
import CompGroupAdd  from '@/components/Comp_Group_Add_Batch';

export default {
    components: { CompGroupAdd },
    props: [ 'data_profs' , 'data_codes', 'data_courses'  ],

data() {
    return {
            isLoading:false,
             data_add_group:[], //, 'data_add_group'
}},
// END data()
 
created() {
    this.group_add_click()  
},
// END CREATEd

methods: {

emit_course_remove:function(index) {
    this.data_add_group.splice(index,1)
},
emit_student_list:function(index, vals) {
// EMITTED WHEN ADDING STUDENTS TO NEW GRP
    this.data_add_group[index].students = vals
},

group_insert_check_confirm:function() {
    this.$emit('emit_group_insert_check_confirm', this.data_add_group)

},


group_add_click:function() {

        var obj = {};
        obj.new_grp_id= 0
        obj.new_grp_id_course= 0
        obj.new_grp_course_title=''
        obj.new_grp_code= ''
        obj.new_grp_sess= ''
        obj.new_grp_ann=  ''
        obj.new_grp_dt_start=''
        obj.new_grp_dt_end=''
        obj.new_grp_sessann=''
        obj.new_grp_prof1=''
        obj.new_grp_prof2=''
        obj.students=[] // FOR THE STUDENTS SELECTED
        obj.ponderation=[]
        this.data_add_group.unshift(obj)


},

// GENERATE A NEW ID! 
randomKey:function() {
return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
    var r = Math.random() * 16 | 0, v = c == 'x' ? r : (r & 0x3 | 0x8);
    return v.toString(16);
});},
}, // END METHODS




} // END EXPORT


</script>